<div class="footer__details">
    <div class="copyrightfooter">
        <span class="ml-2">Powered by Bay6.ai, Inc. | Version 3.0</span>
        <p>Copyright © {{currentYear}} All Rights Reserved</p>
    </div>
    
</div>